import type { MuxAssetResponse, MuxUploadResponse } from "./muxUploadTypes";

export default async (options: Map<string, string>) => {
    options.set("muxId", "");

    alert("Uploading to MUX. There will be another alert when it finishes");

    let notification: Notification | null = null;

    if (Notification.permission === "granted") {
        notification = new Notification("Uploading to MUX", {
            body: "Uploading video to Mux. This may take a few minutes.",
        });
    } else {
        Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
                notification = new Notification("Uploading to MUX", {
                    body: "Uploading video to Mux. This may take a few minutes.",
                });
            }
        });
    }
    const file = options.get("mainVideoSrc");
    if (!file) return;

    const fileUrl = new URL(file);
    fileUrl.searchParams.delete("optimized");

    // Get authenticated URL from Cloudflare Worker
    const response = await fetch("https://mux-video-upload.skywire-s-account.workers.dev/", {
        method: "POST",
    });

    const { data } = (await response.json()) as MuxUploadResponse;
    const imageResponse = await fetch(fileUrl);
    const blob = await imageResponse.blob();
    // Upload video using UpChunk
    try {
        await fetch(data.url, {
            method: "PUT",
            body: blob,
            headers: { "content-type": blob.type },
        });

        //now to get the videoId
        const assetResponse = await fetch(
            `https://mux-video-upload.skywire-s-account.workers.dev/?uploadId=${data.id}`,
            {
                method: "GET",
            },
        );

        const assetsData = (await assetResponse.json()) as MuxAssetResponse;
        alert("Uploading to MUX complete");
        if (Notification.permission === "granted") {
            notification?.close();
        }
        options.set("muxId", assetsData.data.playback_ids[0].id);
    } catch (error) {
        console.error(error);
    }
};
